export const getReportCategoryList = communityId => {
  return (
    [
      {
        name: `Breaks r/${communityId} rules`,
        annotation: 'Posts, comments, or behavior that breaks adsfj community rules.',
        question: 'Which community rule does this violate?',
        answers: [
          'Custom response'
        ]
      },
      {
        name: 'Harassment',
        annotation: 'Harassing, bullying, intimidating, sexualizing, or abusing an individual or group of people with the result of discouraging them from participating.',
        question: 'Who is the harassment towards?',
        answers: [
          'You', 'Someone else'
        ]
      },
      {
        name: 'Threatening violence',
        annotation: 'Encouraging, glorifying, or inciting violence or physical harm against individuals or groups of people, places, or animals.',
        question: 'Who is the threat towards?',
        answers: [
          'You', 'Someone else'
        ]
      },
      {
        name: 'Hate',
        annotation: 'Promoting hate or inciting violence based on identity or vulnerability.',
        question: 'hmm',
        answers: [
          ''
        ]
      },
      {
        name: 'Minor abuse or sexualization',
        annotation: 'Sharing or soliciting content involving abuse, neglect, or sexualization of minors or any predatory or inappropriate behavior involving minors.',
        question: 'What type of minor abuse or sexualization is this?',
        answers: [
          'Sexual or suggestive content',
          'Predatory or inappropriate behavior',
          'Content involving physical or emotional abuse or neglect'
        ]
      },
      {
        name: 'Sharing personal information',
        annotation: 'Sharing or threatening to share private, personal, or confidential information about someone.',
        question: 'Whose personal information is it?',
        answers: [
          'Yours', 'Someone else\'s'
        ]
      },
      {
        name: 'Non-consensual intimate media',
        annotation: 'Sharing, threatening to share, or soliciting intimate or sexually-explicit content of someone without their consent (including fake or "lookalike" pornography).',
        question: 'Who is the non-consensual intimate media of?',
        answers: [
          'You', 'Someone else'
        ]
      },
      {
        name: 'Prohibited transaction',
        annotation: 'Soliciting or facilitating transactions or gifts of illegal or prohibited goods and services.',
        question: 'hmm',
        answers: [
          ''
        ]
      },
      {
        name: 'Impersonation',
        annotation: 'Impersonating an individual or entity in a misleading or deceptive way. This includes deepfakes, manipulated content, or false attributions.',
        question: 'Who is being impersonated?',
        answers: [
          'You or an individual or entity you represent',
          'Someone else'
        ]
      },
      {
        name: 'Copyright violation',
        annotation: 'Content posted to Reddit that infringes a copyright you own or control. (Note: Only the copyright owner or an authorized representative can submit a report.)',
        question: 'Whose copyright is it?',
        answers: [
          'Yours or an individual or entity you represent',
          'Someone else\'s'
        ]
      },
      {
        name: 'Trademark violation',
        annotation: 'Content posted to Reddit that infringes a trademark you own or control. (Note: Only the trademark owner or an authorized representative can submit a report.)',
        question: 'Whose trademark is it?',
        answers: [
          'Yours or an individual or entity you represent',
          'Someone else\'s'
        ]
      },
      {
        name: 'Self-harm or suicide',
        annotation: 'Behavior or comments that make you think someone may be considering suicide or seriously hurting themselves.',
        question: 'hmm',
        answers: [
          ''
        ]
      },
      {
        name: 'Spam',
        annotation: 'Repeated, unwanted, or unsolicited manual or automated actions that negatively affect redditors, communities, and the Reddit platform.',
        question: 'What type of spam is this?',
        answers: [
          'Unsolicited chat or private messaging',
          'Excessive posting or commenting in a community',
          'Excessive reposting to farm karma or manipulate conversations',
          'Sharing harmful links such as malware or phishing attempts',
          'Disruptive use of bots or AI',
          'Other'
        ]
      },
      {
        name: 'Contributor Program violation',
        annotation: 'Contains sexual content or content with recreational drug use, graphic violence, gambling, firearms, or monetary solicitation that’s ineligible for contributor monetization.',
        question: 'What type of Contributor Program violation is this?',
        answers: [
          'Sexual or suggestive content',
          'Graphic or violent content',
          'Content involving recreational drug use, gambling or firearms',
          'Encouraging donations to charitable or political causes',
          'Promoting deceptive money-making services',
          'Engaging in illegal or harmful behavior'
        ]
      }
    ]
  )
}
